
<div>
  <slot v-if="disabled"></slot>
  <template v-else-if="reverseScroll">
    <infinite-loading direction="top" @infinite="infiniteLoadHandler" :identifier="identifier">
      <!-- overwriting vue-infinite-loading default messages -->
      <template v-slot:spinner>
        <slot name="spinner">
          <div>Loading...</div>
        </slot>
      </template>
      <template v-slot:no-more>
        <slot name="no-more">
          <span class="sr-only">You've reached the end of the list</span>
        </slot>
      </template>
      <template v-slot:no-results>
        <slot name="no-results">
          <span class="sr-only">No results found.</span>
        </slot>
      </template>
      <template v-slot:error="{ trigger }">
        Loading failed. Error has occurred.<br><button @click="trigger" class="btn-try-infinite">Retry</button>
      </template>
    </infinite-loading>
    <slot></slot>
  </template>
  <div v-else v-infinite-scroll="loadMore" infinite-scroll-immediate-check infinite-scroll-disabled="disableInfiniteScroll" infinite-scroll-distance="10">
    <slot></slot>

    <div class="d-flex justify-content-center infinite-scroll-end">
      <div v-if="busy">
        <div class="spinner-border" role="status">
          <span class="sr-only" >Loading...</span>
        </div>
        <span v-if="hasText">Loading {{text}}...</span>
        <span v-else>Loading...</span>
      </div>
      <div v-else-if="fullyLoaded && empty">{{emptyMessage}}</div>
      <div v-else-if="fullyLoaded">{{fullyLoadedMessage}}</div>
      <!-- else, intentionally empty -->
    </div>
  </div>
</div>

